import { useTranslation } from 'react-i18next';
import { ButtonLink } from '@anytag/shared-atoms';
import { useAllPackagesQuery } from '@anytag/graphql';
import { Header, ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useInfluencerPackagePermissions, useUserRoles } from '@anytag/auth';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { usePackagesFilter, PackagesFilter, PackagesList } from '@anytag/shared-organisms';

export const Packages = () => {
  const { t } = useTranslation();
  const { isAgency, isAdvertiser } = useUserRoles();
  const { hideAddPackageBtn } = useInfluencerPackagePermissions();
  useUpdateDocumentTitle({ title: 'documentTitle.Packages Search', appHeader: 'appHeader.Packages Search' });
  const { page, limit, filter } = usePackagesFilter();
  const { data, previousData, loading } = useAllPackagesQuery({
    fetchPolicy: 'no-cache',
    skip: !filter,
    variables: getValuableVariables({
      limit,
      offset: getOffset(page, limit),
      keyword: filter?.keyword,
      countryIds: filter?.countryIds
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.allPackagesCount?.totalNumber;
  const hasCreatePackageBtn = !(isAgency || isAdvertiser) && !hideAddPackageBtn;

  return (
    <div>
      <Header>
        {hasCreatePackageBtn ? (
          <ButtonLink
            variant="solid"
            to="/package/add"
            title={t('Button.Add Package')}
            className="ml-auto min-w-36 capitalize"
            prefixIcon={{ icon: 'plus', size: '10px' }}
          />
        ) : null}
      </Header>

      <ListWithPagination pagination={{ totalRecords }}>
        <PackagesFilter />
        <PackagesList loading={loading} totalRecords={totalRecords} data={result?.allPackages || []} />
      </ListWithPagination>
    </div>
  );
};
